import Resource from './Resource';

class Segments extends Resource {
	constructor() {
		super('segments');
		this.dateFields = ['modDate', 'createDate'];
	}

	new() {
		return {
			name: '',
			description: '',
			nrOfContacts: 0,
			filter: []
		};
	}
}

const resource = new Segments();

export default resource;
